import React from 'react';
import PropTypes from 'prop-types';
import cssModule from 'react-css-modules';
import { connect } from 'react-redux';

import {
  getMatchGameScore,
  getMatchTeams,
  getMatchTennisDouble,
  getReadyMatchId,
} from 'reducers';

import style from 'newDesign/modules/common/components/oddsPanel/scoreBoard/ScoreBoard.scss';

const mapStateToProps = state => ({
  teams: getMatchTeams(state, getReadyMatchId(state)),
  gameScore: getMatchGameScore(state, getReadyMatchId(state)),
  tennisDouble: getMatchTennisDouble(state, getReadyMatchId(state)),
});

const getTeamLabel = (team, tennisDouble) => {
  if (!team || !Array.isArray(team) || !team.length) return '';
  const targetTeam = team[0] || {};

  if (!tennisDouble) {
    return targetTeam.abbr || targetTeam.name;
  }

  // Check if abbr for doubles exists and whether it matches x/x format
  const { abbr } = targetTeam;
  const abbrIsDoubleFormat = /^[A-Za-z]\/[A-Za-z]$/.test(abbr || '');

  if (abbr && abbrIsDoubleFormat) {
    return abbr;
  }

  // Otherwise generate abbreviation from name if it contains "/"
  const { name } = targetTeam;
  if (name.includes('/')) {
    const [p1, p2] = name.split('/');
    const newAbbr = `${p1.trim()[0]}/${p2.trim()[0]}`;
    return newAbbr.toUpperCase();
  }

  return abbr || name;
};

const TableRowName = ({
  teams, tennisDouble, side, gameScore,
}) => {
  const { service } = gameScore;

  let homeTeam;
  let awayTeam;
  let serveIndicator = null;

  if (tennisDouble) {
    homeTeam = tennisDouble.home;
    awayTeam = tennisDouble.away;
  } else if (teams) {
    homeTeam = teams.home;
    awayTeam = teams.away;
  }

  if ((service === '1' && side === 'home') || (service === '2' && side === 'away')) {
    serveIndicator = (<div styleName='table__row__serve-circle' className=' flex' />);
  }

  const team = side === 'home' ? homeTeam : awayTeam;

  return (
    <div className='flex flex-1 items-center'>
      <h3 className='fs-18 font-second--bold whitespace-nowrap'>
        {getTeamLabel(team, tennisDouble)}
      </h3>
      {serveIndicator}
    </div>
  );
};

TableRowName.propTypes = {
  teams: PropTypes.object,
  tennisDouble: PropTypes.object,
  side: PropTypes.string.isRequired,
  gameScore: PropTypes.object,
};

TableRowName.defaultProps = {
  teams: {
    home: [{ name: '', abbr: '' }],
    away: [{ name: '', abbr: '' }],
  },
  tennisDouble: null,
  gameScore: {
    home: '-',
    away: '-',
  },
};

const TableRowNameStyled = cssModule(TableRowName, style);
export default connect(mapStateToProps)(TableRowNameStyled);
